import { keyMap } from '@locales/lokalise/keyMap';
import { AxiosError } from 'axios';
import { showForbiddenNotificationDialog } from 'components/shared/errorHandling/userErrorHandling';
import { NotificationDialog } from 'components/shared/modal';
import { mobxStore } from 'store/mobx/mobx.store';
import { getMemoryUserId, getCurrentSessionUserId } from 'utils/userInfoStore';
import ApiUrls from './apiUrls';

const getStatus = (error: AxiosError) => {
  if (error && error.response && error.response.status) {
    return error.response.status;
  }
  return null;
};

export const internalOnErrorInterceptor = (error: AxiosError) => {
  const status = getStatus(error);

  const requestUrl = error.isAxiosError ? error.config.url : '';

  const ignore401 = requestUrl?.includes(ApiUrls.account.getUserSettings) && error.config.params.initialAuth === true;

  if (status === 401 && !ignore401) {
    mobxStore.authStore.signOutAndShowSessionExpiredNotificationDialog({
      skipSignOutRequest: true,
    });
  }

  if (status === 403) {
    const errorModel = error?.response?.data;

    if (typeof errorModel === 'string' || errorModel instanceof ArrayBuffer) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      showForbiddenNotificationDialog(error.response as any);
    } else if (errorModel.errorMessage) {
      NotificationDialog.show(errorModel.errorMessage, 'error');
    }
  }

  if (status === 503) {
    NotificationDialog.show(keyMap.sharedSystemError503, 'error');
  }

  return Promise.reject(error);
};

export const affectedSessionInterceptor = () => {
  const memoryId = getMemoryUserId();
  const currentSessionUserId = getCurrentSessionUserId();

  if (memoryId && currentSessionUserId && memoryId !== currentSessionUserId) {
    NotificationDialog.show(keyMap.sharedSystemInvalidSession, 'error');

    throw new Error(keyMap.sharedSystemInvalidSession);
  }
};
